import React from 'react';
import InfoField from './InfoField';

const CriminalCheckSection = ({ criminalChecks }) => {
  if (!criminalChecks || criminalChecks.length === 0) {
    return (
      <div className="report-section">
        <h2 className="section-title">Criminal Check Details</h2>
        <p>No criminal check details available.</p>
      </div>
    );
  }

  return (
    <div className="report-section">
      <h2 className="section-title">Criminal Check Details</h2>
      {criminalChecks.map((check, index) => (
        <div key={index} className="criminal-check-entry-card">
          <h3>Criminal Check Entry {index + 1}</h3>
          <div className="grid-container">
            <InfoField label="Year" value={check.year || 'N/A'} />
            <InfoField label="Petitioner" value={check.petitioner || 'N/A'} />
            <InfoField label="Respondent" value={check.respondent || 'N/A'} />
            <InfoField label="Respondent Address" value={check.respondentAddress || 'N/A'} />
            <InfoField label="State" value={check.state || 'N/A'} />
            <InfoField label="Filing Number" value={check.filingNumber || 'N/A'} />
            <InfoField label="Case Name" value={check.caseName || 'N/A'} />
            <InfoField label="Case Status" value={check.caseStatus || 'N/A'} />
            <InfoField label="Case Number" value={check.caseNumber || 'N/A'} />
            <InfoField label="Case Type" value={check.caseType || 'N/A'} />
            {check.firLink && (
              <InfoField label="FIR Link" value={<a href={check.firLink} target="_blank" rel="noopener noreferrer">View FIR</a>} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CriminalCheckSection;